import styled from 'styled-components';

import {Device} from '../../../../constants';

interface Props {}
const VBucksContent = styled.div<Props>`
  display: flex;
  width: 100%;
  max-width: 40em;
  position: relative;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  left: 2em;

  && {
    h2 {
      font-size: 4em;
      line-height: 1;
      color: #ffda0b;
      text-shadow: 0 0 8px rgba(0, 0, 0, 0.8), 0px 5px 8px rgba(0, 0, 0, 0.3);
    }

    p {
      font-size: 1.3em;
      color: #fff;
      width: 100%;
      max-width: 30em;
      text-shadow: 0 0 10px #000, 0 0 15px rgba(0, 0, 0, 0.4);
    }
  }

  @media screen and (max-width: 975px) {
    position: absolute;
    max-width: 100%;
    padding: 0 1em;
    top: 2em;
    left: 0;

    h2,
    p {
      text-align: center;
      margin: 0 auto;
    }
  }

  @media screen and ${Device.mobileL} {
    && {
      h2 {
        font-size: 2.5em;
        margin-bottom: 0.5em;
      }

      p {
        font-size: 1em;
      }
    }
  }
`;

export default VBucksContent;
